import React from 'react';
import LinkStyleToolbar from '../shared/LinkStyleToolbar';

/* La toolbar et la conversion en CSS sont partagées avec le pied de page
   (`shared/LinkStyleToolbar`) : les deux les écrivaient à l'identique. */
export { linkStyleToCss } from '../shared/LinkStyleToolbar';

/**
 * Style commun des liens du menu. La couleur de survol / page active reste un
 * paramètre séparé (accent), le menu étant le seul à avoir une page active.
 */
export default function SiteHeaderLinkStyleField({ value, onChange }) {
  return <LinkStyleToolbar value={value} onChange={onChange} />;
}
